import { graphql } from "gql";

const INTERNAL_ADMIN_TAG_PROFILE_QUERY = graphql(`
  query InternalAdminTagProfile($id: ID!) {
    internalAdminTag(id: [$id]) {
      ...InternalAdminTagProfile
    }
  }
`);

export default INTERNAL_ADMIN_TAG_PROFILE_QUERY;
